'use strict';

var utilities_combineClasses = require('../_chunks/combineClasses-5P8GTQkg.js');



exports.combineClasses = utilities_combineClasses.combineClasses;
//# sourceMappingURL=combineClasses.js.map
